import { action, createAsyncAction } from 'typesafe-actions';
import { IBrandShopRequest, ILandingPageRequest, ILayoutPageRequest, IOurStoryRequest } from '@/api/layout-page';
import { ILayoutPage } from '@/store/layout-page/layout-page.reducer';

export const FETCH_HOMEPAGE_REQUEST = 'layoutPage/FETCH_HOMEPAGE_REQUEST';
export const FETCH_HOMEPAGE_SUCCESS = 'layoutPage/FETCH_HOMEPAGE_SUCCESS';
export const FETCH_HOMEPAGE_ERROR = 'layoutPage/FETCH_HOMEPAGE_ERROR';
export const CLEAR_HOMEPAGE = 'layoutPage/CLEAR_HOMEPAGE';
export const CLEAR_BRAND_SHOP_PAGE = 'layoutPage/CLEAR_BRAND_SHOP_PAGE';

export const FETCH_LAYOUT_PAGE_REQUEST = 'layoutPage/FETCH_LAYOUT_PAGE_REQUEST';
export const FETCH_LAYOUT_PAGE_SUCCESS = 'layoutPage/FETCH_LAYOUT_PAGE_SUCCESS';
export const FETCH_LAYOUT_PAGE_ERROR = 'layoutPage/FETCH_LAYOUT_PAGE_ERROR';

export const FETCH_OUR_STORY_PAGE_REQUEST = 'layoutPage/FETCH_OUR_STORY_PAGE_REQUEST';
export const FETCH_OUR_STORY_PAGE_SUCCESS = 'layoutPage/FETCH_OUR_STORY_PAGE_SUCCESS';
export const FETCH_OUR_STORY_PAGE_ERROR = 'layoutPage/FETCH_OUR_STORY_PAGE_ERROR';

export const FETCH_BRAND_SHOP_PAGE_REQUEST = 'layoutPage/FETCH_BRAND_SHOP_PAGE_REQUEST';
export const FETCH_BRAND_SHOP_PAGE_SUCCESS = 'layoutPage/FETCH_BRAND_SHOP_PAGE_SUCCESS';
export const FETCH_BRAND_SHOP_PAGE_ERROR = 'layoutPage/FETCH_BRAND_SHOP_PAGE_ERROR';

export const FETCH_LANDING_PAGE_REQUEST = 'layoutPage/FETCH_LANDING_PAGE_REQUEST';

export const fetchHomepage = createAsyncAction(FETCH_HOMEPAGE_REQUEST, FETCH_HOMEPAGE_SUCCESS, FETCH_HOMEPAGE_ERROR)<
    ILayoutPageRequest,
    ILayoutPage,
    Error
>();

export const fetchLayoutPage = createAsyncAction(
    FETCH_LAYOUT_PAGE_REQUEST,
    FETCH_LAYOUT_PAGE_SUCCESS,
    FETCH_LAYOUT_PAGE_ERROR
)<ILayoutPageRequest, ILayoutPage, Error>();

export const fetchOurStoryPage = createAsyncAction(
    FETCH_OUR_STORY_PAGE_REQUEST,
    FETCH_OUR_STORY_PAGE_SUCCESS,
    FETCH_OUR_STORY_PAGE_ERROR
)<IOurStoryRequest, ILayoutPage, Error>();

export const fetchLandingPage = createAsyncAction(
    FETCH_LANDING_PAGE_REQUEST,
    FETCH_LAYOUT_PAGE_SUCCESS,
    FETCH_LAYOUT_PAGE_ERROR
)<ILandingPageRequest, ILayoutPage, Error>();

export const fetchBrandShopPage = createAsyncAction(
    FETCH_BRAND_SHOP_PAGE_REQUEST,
    FETCH_BRAND_SHOP_PAGE_SUCCESS,
    FETCH_BRAND_SHOP_PAGE_ERROR
)<IBrandShopRequest, ILayoutPage, Error>();

export const clearHomePage = () => action(CLEAR_HOMEPAGE);
export const clearBrandShopPage = () => action(CLEAR_BRAND_SHOP_PAGE);
